import { useEffect } from "react";
import { useDialog } from "../hooks/useDialog";

export function ShowStickyError() {
  const MLDialog = useDialog();

  useEffect(() => {
    MLDialog.showSnackbar("E-mail o password sbagliata! Riprova!", { variant: "error" });
  }, []);

  return <></>;
}
